/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_td_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It splits both texts into lines and finds the longest common sequence, so unchanged lines line up and only real additions and removals are highlighted.`)
};

const es_td_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide ambos textos en líneas y encuentra la secuencia común más larga, por lo que las líneas sin cambios se alinean y solo se resaltan las adiciones y eliminaciones reales.`)
};

const de_td_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es teilt beide Texte in Zeilen auf und findet die längste gemeinsame Sequenz, sodass sich unveränderte Zeilen ausrichten und nur echte Hinzufügungen und Entfernungen hervorgehoben werden.`)
};

const nl_td_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het verdeelt beide teksten in regels en vindt de langste gemeenschappelijke reeks, zodat ongewijzigde regels worden uitgelijnd en alleen echte toevoegingen en verwijderingen worden gemarkeerd.`)
};

const fr_td_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il divise les deux textes en lignes et trouve la plus longue séquence commune, afin que les lignes inchangées s'alignent et que seules les additions et les suppressions réelles soient mises en surbrillance.`)
};

const it_td_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide entrambi i testi in righe e trova la sequenza comune più lunga, quindi le righe non modificate si allineano e solo le aggiunte e i rimozioni reali vengono evidenziate.`)
};

const pt_br2_td_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele divide os dois textos em linhas e encontra a sequência comum mais longa, para que as linhas inalteradas se alinhem e apenas adições e remoções reais sejam destacadas.`)
};

const pt_td_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide ambos os textos em linhas e encontra a sequência comum mais longa, para que as linhas não alteradas se alinhem e apenas as adições e remoções reais sejam destacadas.`)
};

const ja_td_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`両方のテキストを行に分割し、最長共通シーケンスを見つけるため、変更されていない行が並び、実際の追加と削除だけがハイライト表示されます。`)
};

const zh_td_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它会将两段文本拆分成行，并查找最长公共序列，从而使未改动的行保持对齐，只高亮显示真正的新增和删除内容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const td_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.td_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("td_faq1_a", locale)
	if (locale === "en") return en_td_faq1_a(inputs)
	if (locale === "es") return es_td_faq1_a(inputs)
	if (locale === "de") return de_td_faq1_a(inputs)
	if (locale === "nl") return nl_td_faq1_a(inputs)
	if (locale === "fr") return fr_td_faq1_a(inputs)
	if (locale === "it") return it_td_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_td_faq1_a(inputs)
	if (locale === "pt") return pt_td_faq1_a(inputs)
	if (locale === "ja") return ja_td_faq1_a(inputs)
	return zh_td_faq1_a(inputs)
};